<template>
  <div v-if="Object.keys(currentProduct).length" class="product-status-card">
    <div v-if="!loggedin" class="not-login">
      <div class="login-icon">
        <img src="@/assets/image/status/icon_fail.svg">
      </div>
      <div class="login-guide">
        <div class="title">{{ $t('interested') }}</div>
        <div class="desc">{{ $t('startInvesting') }}</div>
      </div>
      <div class="login-btn">
        <md-button type="primary" round @click="switchRoute('Login')">
          {{ $t('login') }}
        </md-button>
      </div>
    </div>
    <div v-else class="loggedin">
      <div v-if="userInfo.status === 'ENABLED'" class="invest-form">
        <div class="form-item">
          <div class="form-label">{{ type =='fixed' ? $t('balanceLabel'): $t('flexibleBalanceLabel') }}</div>
          <div class="form-control-static balance">
            <span>{{ userBalance | formatMoney }}</span>
          </div>
        </div>
        <div class="form-item amount">
          <!-- 现金券和满加券显示额外的投资金额 -->
          <div class="form-label">{{ $t('amountLabel') }}</div>
          <div class="form-control">
            <div v-if="currentProduct.type == 'FIXED_TRIAL'" class="form-control-static balance">
              <span>{{ selectedCoupon ? selectedCoupon.rebate : 0 | formatMoney }}</span>
            </div>
            <div v-else class="amount-control">
              <div class="amount-input" :class="{'has-extra':hasExtraAmount}">
                <md-field>
                  <md-input-item
                    name="amount"
                    type="money"
                    v-model="form.amount"
                    v-validate="amountRule"
                    @change="delayExcute(1000, getRevenue)"
                    class="input-money-container bordered"
                    :class="{'danger':errors.first('amount')}"
                    :error="errors.first('amount')"
                  >
                    <cleave slot="left" v-model="form.amount" :options="amountFormatOptions"
                            class="input-money-inner"></cleave>
                  </md-input-item>
                </md-field>
                <div class="amount-extra" v-if="hasExtraAmount">
                  + {{ selectedCoupon.rebate || 0 }}
                </div>
              </div>
              <div class="btn-use-all">
                <md-button type="primary" @click="form.amount = userBalance">
                  {{ $t('useAll') }}
                </md-button>
              </div>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            {{ type === 'fixed'? $t('revenueLabel') : $t('flexibleRevenueLabel') }}
          </div>
          <div class="form-control-static">
            <div v-if="currentProduct.type == 'FIXED_TRIAL'">{{ extraRevenue | formatMoney }}</div>
            <div v-else class="revenue">
              <div>{{ type === 'fixed' ? revenue: dailyRevenue | formatMoney }}</div>
              <!-- 现金券或加息券显示额外的收益 -->
              <div class="revenue-extra">
                <div v-if="type === 'fixed' && extraRevenue">
                  + {{ extraRevenue | formatMoney(true, true) }}
                </div>
                <div v-if="type === 'flexible' && extraDailyRevenue">
                  + {{ extraDailyRevenue | formatMoney(true, true) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="coupon-field" @click="showSelector('coupon')">
            <div v-if="hasSelectCoupon">
              <span class="coupon-name">{{ selectedCoupon.displayName[locale] }}</span>
              <span class="coupon-value">{{ selectedCouponValue }}</span>
            </div>
            <div v-else class="unselected">
              <div>{{ $t('chooseCoupon') }}</div>
              <div class="coupon-count">{{ couponList.length }}</div>
            </div>
            <md-icon name="arrow-down" size="sm"></md-icon>
          </div>
          <coupon-selector
            :visible="selectorVisible.coupon"
            :inputAmount="Number(form.amount)"
            :couponList="couponList"
            :selectedId="hasSelectCoupon ? selectedCoupon.id : ''"
            :isTrial="currentProduct.type === 'FIXED_TRIAL'"
            @hideDialog="selectorVisible.coupon = false"
            @onSelectCoupon="onSelectCoupon"
          ></coupon-selector>
        </div>
        <div class="form-item">
          <div class="form-label">
            {{ $t('paymentChannel') }}
          </div>
          <div class="payment-channel-list">
            <md-radio-list
              ref="radio"
              :options="paymentChannelOptions"
              v-model="paymentChannel"
              icon-position="left"
              icon-size="md"
              icon-disabled="check"
            >
              <template slot-scope="{ option }">
                <div v-if="option.value === 'gopay'" class="channel-item">
                  <div>
                    <img class="logo-gopay" src="@/assets/image/product/logo-gopay.png">
                  </div>
                  <div class="gopay-limit">Maximum Rp10.000.000</div>
                </div>
                <div v-if="option.value === 'balance'" class="channel-item">
                  <div v-text="option.text"></div>
                  <div>{{ userBalance | formatMoney }}</div>
                </div>
              </template>
            </md-radio-list>
          </div>
        </div>
        <div class="form-item btn-submit">
          <button-primary
            type="primary"
            @click="nextStep"
            :loading="loading"
          >
            {{ $t('startFunding') }}
          </button-primary>
        </div>
      </div>
      <verification-result v-else :status="userInfo.status"></verification-result>
    </div>
    <product-topup-tip :visible="topupTipVisible" @hideDialog="topupTipVisible = false"></product-topup-tip>
    <verify-guide-dialog :visible="verifyDialogVisible" @hideDialog="verifyDialogVisible = false"></verify-guide-dialog>
    <bind-bank-dialog
      :visible="bindBankDialogVisible"
      @hideDialog="hideBindBankDialog"
    ></bind-bank-dialog>
    <electronic-contract-form
      :visible="contractFormDialogVisible"
      @DSRegistCompleted="DSRegistCompleted"
      @hideDialog="contractFormDialogVisible = false"
    >
    </electronic-contract-form>
    <dialog-light-tip
      :title="$t('DSContractSignTip')"
      :cancel-text="$t('cancel')"
      :confirm-text="$t('signNow')"
      :visible="contractConfirmDialogVisible"
      @hideDialog="contractConfirmDialogVisible = false"
      @confirm="confirmSignContract(needActivateDS)"
    ></dialog-light-tip>
    <div class="iframe-wrapper" v-if="DSWebviewVisible">
      <iframe id="DS-webview" scrolling="yes"></iframe>
    </div>
  </div>
</template>
<script>
import { Field, FieldItem, InputItem, RadioList } from 'mand-mobile'
import Cleave from 'vue-cleave-component'
import VerifyGuideDialog from '@/components/common/VerifyGuideDialog'
import VerificationResult from '@/components/common/VerificationResult'
import ProductTopupTip from '@/components/product/ProductTopupTip'
import CouponSelector from '@/components/product/CouponSelector'
import { amountOptions } from '@/lib/cleave'
import productMixin from '@/mixins/product'
import bindBankMixin from '@/mixins/bind-bank'
import ElectronicContractForm from '@/components/product/ElectronicContractForm'

export default {
  i18n: {
    messages: {
      en: {
        login: 'Login',
        interested: 'Interested?',
        startInvesting: 'Sign in to start funding',
        balanceLabel: 'Current Balance',
        flexibleBalanceLabel: 'Unused Balance',
        amountLabel: 'Your total lending commitment',
        minValue: 'At least {minValue}',
        revenueLabel: 'Profit',
        flexibleRevenueLabel: 'Interests Per Day',
        startFunding: 'Start Funding',
        chooseCoupon: 'Choose Coupon',
        useAll: 'Use All',
        paymentChannel: 'Payment Channel',
        unusedBalance: 'Unused Balance:',
        gopayLimitTip: 'You can only transfer Rp 1.000.000',
        ok: 'OK',
        cancel: 'Cancel',
        signNow: 'Sign Now',
        DSContractSignTip: 'According to OJK requirements, an electronic contract needs to be signed when funding',
        DSRegistFailed: 'Information verification failed, please try again or contact customer service',
        contractSignFailed: 'Electronic contract failed to sign, please try again or contact customer service',
      },
      id: {
        login: 'Masuk',
        interested: 'Tertarik?',
        startInvesting: 'Masuk untuk mulai pendanaan.',
        balanceLabel: 'Nominal',
        flexibleBalanceLabel: 'Sisa Nominal',
        amountLabel: 'Jumlah pendanaan Anda',
        minValue: 'At least {minValue}',
        revenueLabel: 'Keuntungan',
        flexibleRevenueLabel: 'Keuntungan Per Hari',
        startFunding: 'Transfer Tunai',
        chooseCoupon: 'Pilih Kupon',
        useAll: 'Pakai Semua',
        paymentChannel: 'Payment Channel',
        unusedBalance: 'Sisa Nominal:',
        gopayLimitTip: 'You can only transfer Rp 1.000.000',
        ok: 'OK',
        cancel: 'Batal',
        signNow: 'Tanda Tangan Sekarang',
        DSContractSignTip: 'Menurut persyaratan OJK, kontrak elektronik perlu ditandatangani ketika pendanaan',
        DSRegistFailed: 'Verifikasi informasi gagal, silakan coba lagi atau hubungi customer service',
        contractSignFailed: 'Kontrak elektronik gagal ditandatangani, silakan coba lagi atau hubungi customer service',
      },
    },
  },
  components: {
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [RadioList.name]: RadioList,
    Cleave,
    VerificationResult,
    VerifyGuideDialog,
    ProductTopupTip,
    CouponSelector,
    ElectronicContractForm,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    flexibleRemainAmount: {
      type: Number,
      default: 0,
    },
  },
  mixins: [
    productMixin,
    bindBankMixin,
  ],
  data() {
    const userAccount = this.$store.state.accountOverview.find(account => account.currencyType === 'IDR')
    return {
      amountFormatOptions: amountOptions,
      validateMessage: {
        en: {
          custom: {
            amount: {
              max_value: (field, value) => 'Maximum investment amount exceed the limit',
            },
          },
        },
        id: {
          custom: {
            amount: {
              max_value: (field, value) => 'Jumlah maximum pendanaan melebihi batas',
            },
          },
        },
      },
      topupTipVisible: false,
      agreementVisible: false,
      verifyDialogVisible: false,
      selectorVisible: {
        coupon: false,
      },
      couponList: [],
      paymentChannelOptions: this.$config.needElectronicContract && (userAccount && userAccount.hasOwnProperty('balance') && !userAccount.balance)
        ? [{ text: '', value: 'gopay', disabled: false }]
        : [{ text: '', value: 'gopay', disabled: false }, { text: this.$t('unusedBalance'), value: 'balance' }],
      paymentChannel: 'gopay',
      loading: false,
      contractFormDialogVisible: false,
      contractConfirmDialogVisible: false,
      needActivateDS: false,
      DSWebviewVisible: false,
      signContractNextStep: '',
      documentId: '',
    }
  },
  computed: {
    loggedin() {
      return this.$store.getters.loggedin
    },
    userAccount() {
      return this.$store.state.accountOverview.find(account => account.currencyType === 'IDR')
    },
    userInfo() {
      console.log(this.$store.state.userInfo)
      return this.$store.state.userInfo
    },
    userBalance() {
      return this.userAccount && this.userAccount.balance ? this.userAccount.balance : 0
    },
    currentProduct() {
      return this.$store.state.currentProduct
    },
    minValue() {
      return this.currentProduct.limitMinAmount || 0
    },
    maxValue() {
      let maxAmount
      const gopayLimit = 10000000
      const investment = this.currentProduct || {}
      const maximumAmount = investment.limitMaxAmount ? investment.limitMaxAmount : Number.MAX_VALUE
      if (this.type === 'flexible') {
        maxAmount = Math.min(maximumAmount, this.flexibleRemainAmount)
      } else {
        maxAmount = maximumAmount
      }
      if (this.$config.needElectronicContract) {
        if (this.userBalance) {
          return Math.min(maxAmount, gopayLimit, this.userBalance)
        } else {
          return Math.min(maxAmount, gopayLimit)
        }
      } else {
        return maxAmount
      }
    },
    amountRule() {
      return {
        required: true,
        min_value: this.minValue,
        max_value: this.maxValue,
        multiplesNumber: this.currentProduct.limitIncrementStep || 0,
        investRemainLimit: this.userBalance,
      }
    },
    selectedCouponValue() {
      // 所选优惠券的面额（金额或加息利率）
      return this.selectedCoupon.percentage ? `${this.selectedCoupon.percentage}%` : this.$options.filters.formatMoney(this.selectedCoupon.rebate)
    },
    hasExtraAmount() {
      // 使用现金券和满加券有额外的投资金额
      const data = this.selectedCoupon
      return data && (data.type === 'CASH_COUPON' || (this.type === 'INVEST_COUPON' && data.strategy === 'REBATE'))
    },
  },
  async mounted() {
    const amount = this.$route.query.amount || ''
    this.form.amount = isNaN(amount) ? '' : amount
    this.$validator.localize(this.validateMessage)

    this.appendSnapScript()
    window.addEventListener('message', this.receiveDSMessage, false)
  },
  methods: {
    appendSnapScript() {
      const snapScript = document.createElement('script')
      snapScript.setAttribute('src', this.$config.snapInfo.snapUrl)
      snapScript.setAttribute('data-client-key', this.$config.snapInfo.snapToken)

      document.head.appendChild(snapScript)
    },
    async getAvailableCoupon() {
      try {
        const params = {
          investmentId: this.currentProduct.id,
        }
        const response = await this.$http.get('/voucher/coupon/available', { params })
        this.couponList = response.data.data || []
        // 如果是体验标 默认选中优惠券并计算收益
        if (this.currentProduct.type === 'FIXED_TRIAL') {
          this.selectedCoupon = this.couponList[0]
          this.getRevenue()
        } else {
          this.selectedCoupon = {}
        }
      } catch (error) {
        console.log(error)
      }
    },
    onSelectCoupon(couponInfo) {
      this.selectedCoupon = couponInfo
      this.getRevenue()
    },
    async nextStep() {
      try {
        if (this.$config.needBindBankPrevious && this.userInfo.bankAccountStatus !== 'PASSED') {
          this.bindBankDialogVisible = true
          return
        }
        // 如果出现所选产品为体验标 但是没有对应对优惠券对情况 提交不往下进行
        if (this.currentProduct.type === 'FIXED_TRIAL' && !this.hasSelectCoupon) {
          return
        }
        const valid = await this.$validator.validate()
        if (!valid) return
        if (this.$config.needElectronicContract) {
          this.handleDsContract()
        } else if (this.paymentChannel === 'gopay') {
          this.investByGopay()
        } else if (this.paymentChannel === 'balance') {
          if (this.form.amount > this.userBalance) {
            this.topupTipVisible = true
            return
          }
          this.investByBalance()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.$toast.hide()
      }
    },
    /**
     * 未注册： 注册DS，激活，签署电子合同，投资
     * 已注册未激活： 激活，签署电子合同，投资
     * 已注册并激活： 签署电子合同，投资
     */
    async handleDsContract() {
      try {
        this.loading = true
        const response = await this.$http.get('/digitsign/status')
        const status = response.data.data
        switch (status) {
          case 'NOT_REGISTER':
            this.contractFormDialogVisible = true
            break
          case 'REGISTERED':
            this.needActivateDS = true
            this.contractConfirmDialogVisible = true
            break
          case 'ACTIVE':
            this.needActivateDS = false
            this.contractConfirmDialogVisible = true
            break
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async DSRegistCompleted() {
      this.contractConfirmDialogVisible = true
      this.confirmSignContract(true)
    },
    async confirmSignContract(needActivate) {
      this.contractConfirmDialogVisible = false
      try {
        if (needActivate) {
          // 激活流程
          const response = await this.$http.post('/digitsign/activate')
          this.DSWebviewVisible = true
          this.signContractNextStep = 'sign'
          this.$nextTick(function() {
            document.getElementById('DS-webview').src = `data:text/html;charset=utf-8,${encodeURIComponent(response.data)}`
          })
        } else {
          this.signContract()
        }
      } catch (e) {
        console.log(e)
      }
    },
    async signContract() {
      try {
        this.loading = true
        const res = await this.$http.post('/digitsign/agreement', {
          investmentId: this.currentProduct.id,
          amount: this.form.amount,
        })
        const documentId = this.documentId = res.data.data
        if (documentId) {
          this.signContractNextStep = 'invest'
        }
        const response = await this.$http.post(`/digitsign/sign?documentId=${documentId}`)
        const data = response.data
        this.DSWebviewVisible = true
        this.$nextTick(function() {
          document.getElementById('DS-webview').src = `data:text/html;charset=utf-8,${encodeURIComponent(data)}`
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async receiveDSMessage(event) {
      if (event.origin === 'https://app.sandbox.midtrans.com' || event.origin === 'https://app.midtrans.com') return
      this.DSWebviewVisible = false
      try {
        if (typeof event.data === 'object' && event.data.result) {
          if (event.data.result === '01') return
          if (event.data.result !== '00') {
            this.$toast.info('Operation Failed!')
            return
          }
        }
        if (typeof event.data === 'string') {
          const result = JSON.parse(event.data)
          if (result.rc !== '00') {
            this.$toast.info('Operation Failed!')
            return
          }
        }
        if (this.signContractNextStep === 'sign') {
          this.signContract()
          return
        }
        if (this.signContractNextStep === 'invest') {
          if (this.paymentChannel === 'gopay') {
            this.investByGopay()
          } else if (this.paymentChannel === 'balance') {
            this.investByBalance()
          }
          this.signContractNextStep = ''
        }
      } catch (error) {
        console.log(error)
      }
    },
    async investByBalance() {
      try {
        this.loading = true
        if (window.bridge && window.bridge.afTrackEvent) {
          window.bridge.afTrackEvent('Invested', '')
        }
        if (this.currentProduct.type === 'FIXED_TRIAL') {
          this.form.amount = 0
        }
        const payload = {
          accountId: this.userAccount.id,
          investmentId: this.currentProduct.id,
          issuedId: this.selectedCoupon.id,
          balance: this.userBalance,
          amount: Number(this.form.amount),
        }
        const res = await this.$http.post('/transaction/invest', payload)
        if (window.bridge && window.bridge.afTrackEvent) {
          window.bridge.afTrackEvent('Invested succeed', '')
        }
        if (this.$config.needElectronicContract) {
          await this.$http.post('/digitsign/agreement/update', {
            orderId: res.data.data.orderId,
            documentId: this.documentId,
          })
        }
        this.$router.push({ name: 'InvestResult' })
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async investByGopay() {
      try {
        this.loading = true
        const payload = {
          referenceId: this.userInfo.id,
          amount: this.form.amount,
          currencyType: 'IDR',
          productId: this.currentProduct.id,
          productName: this.currentProduct.id,
          couponId: this.selectedCoupon && this.selectedCoupon.id ? this.selectedCoupon.id : '',
          productQuantity: 1,
        }
        const response = await this.$http.post('/invested-payment-api/payment/1/invoice', payload)
        const data = response.data.data
        if (data && data.token) {
          window.snap.pay(response.data.data.token, {
            skipOrderSummary: true,
            skipCustomerDetails: true,
            showOrderId: false,
            onSuccess: async (result) => {
              if (this.$config.needElectronicContract) {
                await this.$http.post('/digitsign/agreement/update', { documentId: this.documentId })
              }
              this.$router.push({ name: 'InvestResult' })
            },
            onPending: result => this.$router.push({ name: 'UserTransaction' }),
            onError: result => this.$router.push({ name: 'UserTransaction' }),
            onClose: () => console.log('Customer closed the popup without finishing the payment'),
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    showSelector(name) {
      this.selectorVisible[name] = true
    },
    switchRoute(name) {
      this.$router.push({ name: name })
    },
  },
  watch: {
    currentProduct: function(newVal, oldVal) {
      // 加载用户可用于投资的优惠券
      if (this.loggedin) {
        this.getAvailableCoupon()
      }
    },
    'form.amount': function(newVal, oldVal) {
      if (!this.$config.needElectronicContract || this.userBalance) {
        const gopayAvailable = newVal < 10000000
        this.paymentChannel = gopayAvailable ? 'gopay' : 'balance'
        this.paymentChannelOptions[0].disabled = !gopayAvailable
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receiveDSMessage)
  },
}
</script>

<style lang="stylus" scoped>
.product-status-card {
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: -40px 20px 20px;
  padding: 28px;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  border-radius: 8px;
}

.not-login {
  text-align: center;
  .login-icon {
    margin: 50px 0 20px;
    img {
      width: 46px;
      height: 46px;
    }
  }
  .login-guide {
    margin-bottom: 40px;
    .title {
      font-size: 20px;
      padding-bottom: 5px;
    }
    .desc {
      font-size: 14px;
      color: #666;
    }
  }
  .login-btn /deep/ {
    width: 100%;
  }
}

.loggedin {
  .form-item {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    .form-label {
      font-size: 15px;
      color: #555;
      margin-bottom: 10px;
    }
    .form-control-static {
      font-size: 16px;
      font-weight: bold;
    }
    .balance {
      line-height: 28px;
      display: flex;
      justify-content: space-between;
    }
    .button-topup {
      width: 20vw;
      height: 28px;
      font-size: 12px;
    }
    .button {
      width: 100%;
      border-radius: 50px;
    }
    .revenue {
      display: flex;
      justify-content: flex-start;
      .revenue-extra {
        margin-left: 10px;
        color: color-primary;
        font-weight: bold;
      }
    }
    &.amount {
      .form-control {
        .amount-control {
          display: flex;
          justify-content: flex-start;
          .amount-input {
            width: 100%;
            margin-right: 4px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: nowrap;
            .md-field {
              width: 100%;
            }
            &.has-extra .md-field {
              max-width: 70%;
            }
            .amount-extra {
              margin-left: 6px;
              margin-top: 10px;
              font-size: 16px;
              font-weight: bold;
              color: color-primary;
            }
          }
          .btn-use-all /deep/ {
            .md-button {
              width: auto;
            }
          }
        }
      }
    }
  }
}

.coupon-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 10px 8px;
  font-size: 14px;
  cursor: pointer;
  .coupon-value {
    color: #c2a661;
    font-size: 12px;
    margin-left: 10px;
    font-weight: 500;
  }
  .unselected {
    display: flex;
    justify-content: flex-start;
  }
  .coupon-count {
    margin-left: 10px;
    background-image: url('../../assets/image/user/ticket/tag-coupon-available.png');
    background-size: 100% 100%;
    width: 32px;
    height: 17px;
    line-height: 17px;
    text-align: center;
    font-size: 12px;
    color: #fff;
  }
}

.payment-channel-list /deep/ {
  .md-radio-list {
    .md-radio-item {
      .md-cell-item-body {
        padding: 0;
        min-height: 40px;
        &::before {
          height: 0;
        }
        .md-cell-item-left {
          margin-right: 12px;
        }
      }
      .md-field-item-inner {
        padding: 10px 0;
        &::before {
          background-color: unset;
        }
      }
      &.is-disabled {
        opacity: .4;
      }
    }
  }
  .channel-item {
    display: flex;
    justify-content: flex-start;
    font-size: 14px;
    div:nth-child(1) {
      margin-right: 10px;
    }
  }
  .logo-gopay {
    width: 73px;
    height: 17px;
  }
  .gopay-limit {
    font-size: 9px;
    font-weight: 500;
    color: #979797;
    line-height: 13px;
    border: 1px solid #979797;
    border-radius: 7px;
    display: flex;
    align-items: center;
    padding: 2px 5px;
  }
}

.invest-keyboard {
}

.btn-submit /deep/ {
  .md-icon.icon-svg.md {
    width: 32px;
    height: 32px;
  }
}

.iframe-wrapper
  position fixed
  left 0
  top 0
  right 0
  bottom 0
  overflow-y scroll
  z-index 100000

#DS-webview {
  width 100%
  height 100%
  min-height 100vh
  overflow-y scroll
  z-index 1000000
  background #fff
}
</style>
